import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-acura-link',
    templateUrl: './acura-link.component.html',
    styleUrls: ['./acura-link.component.scss'],
    standalone: false
})
export class AcuraLinkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
